var _ellipse, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessOperation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 155,
    viewBox: "0 0 228 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.124,
    cy: 150.766,
    rx: 80,
    ry: 3.7664,
    fill: "url(#paint0_radial)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3491,
    cy: 51.79,
    r: 5,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.2441,
    cy: 3.89502,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.022,
    cy: 125.895,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.06104,
    y1: 85.46,
    x2: 4.06103,
    y2: 91.46,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.12354,
    y1: 88.71,
    x2: 1.12354,
    y2: 88.71,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 209.311,
    y1: 27.21,
    x2: 209.311,
    y2: 33.21,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 212.374,
    y1: 30.46,
    x2: 206.374,
    y2: 30.46,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 150.077,
    y1: 10.8223,
    x2: 150.077,
    y2: 16.8223,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 153.139,
    y1: 14.0723,
    x2: 147.139,
    y2: 14.0723,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6082 58.4329C67.1145 58.4329 67.525 58.0218 67.525 57.5148C67.525 57.0077 67.1145 56.5967 66.6082 56.5967C66.1019 56.5967 65.6914 57.0077 65.6914 57.5148C65.6914 58.0218 66.1019 58.4329 66.6082 58.4329Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0872 58.4329C70.5935 58.4329 71.004 58.0218 71.004 57.5148C71.004 57.0077 70.5935 56.5967 70.0872 56.5967C69.5809 56.5967 69.1704 57.0077 69.1704 57.5148C69.1704 58.0218 69.5809 58.4329 70.0872 58.4329Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5667 58.4329C74.073 58.4329 74.4835 58.0218 74.4835 57.5148C74.4835 57.0077 74.073 56.5967 73.5667 56.5967C73.0604 56.5967 72.6499 57.0077 72.6499 57.5148C72.6499 58.0218 73.0604 58.4329 73.5667 58.4329Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.476 59.6719H64.7044C64.5254 59.6719 64.3804 59.8169 64.3804 59.9959C64.3804 60.1748 64.5254 60.3199 64.7044 60.3199H180.476C180.655 60.3199 180.8 60.1748 180.8 59.9959C180.8 59.8169 180.655 59.6719 180.476 59.6719Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.033 45.79H48.9271C47.8963 45.79 47.0605 46.6257 47.0605 47.6566V129.762C47.0605 130.793 47.8963 131.629 48.9271 131.629H179.033C180.064 131.629 180.9 130.793 180.9 129.762V47.6566C180.9 46.6257 180.064 45.79 179.033 45.79Z",
    fill: "#DDE4EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.976 45.8457H48.8695C47.8386 45.8457 47.0029 46.6814 47.0029 47.7123V53.1322H180.842V47.7123C180.842 46.6814 180.007 45.8457 178.976 45.8457Z",
    fill: "#8792A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.316 57.2549H52.8642C51.8333 57.2549 50.9976 58.0906 50.9976 59.1215V88.1108C50.9976 89.1417 51.8333 89.9774 52.8642 89.9774H175.316C176.347 89.9774 177.183 89.1417 177.183 88.1108V59.1215C177.183 58.0906 176.347 57.2549 175.316 57.2549Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.682 64.4941H64.7158C63.4907 64.4941 62.4976 65.1765 62.4976 66.0181C62.4976 66.8598 63.4907 67.5422 64.7158 67.5422H159.682C160.907 67.5422 161.9 66.8598 161.9 66.0181C161.9 65.1765 160.907 64.4941 159.682 64.4941Z",
    fill: "#DDE4EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.721 72.1133H64.7158C63.4907 72.1133 62.4976 72.7956 62.4976 73.6373C62.4976 74.479 63.4907 75.1613 64.7158 75.1613H95.721C96.9461 75.1613 97.9392 74.479 97.9392 73.6373C97.9392 72.7956 96.9461 72.1133 95.721 72.1133Z",
    fill: "#DDE4EE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.886 79.7334H64.7158C63.4907 79.7334 62.4976 80.4157 62.4976 81.2574C62.4976 82.0991 63.4907 82.7814 64.7158 82.7814H130.886C132.111 82.7814 133.104 82.0991 133.104 81.2574C133.104 80.4157 132.111 79.7334 130.886 79.7334Z",
    fill: "#DDE4EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.396 94.1006H52.9437C51.9129 94.1006 51.0771 94.9363 51.0771 95.9672V124.957C51.0771 125.987 51.9129 126.823 52.9437 126.823H175.396C176.427 126.823 177.263 125.987 177.263 124.957V95.9672C177.263 94.9363 176.427 94.1006 175.396 94.1006Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.049 101.34H66.5179C65.3371 101.34 64.3799 102.022 64.3799 102.864C64.3799 103.706 65.3371 104.388 66.5179 104.388H158.049C159.23 104.388 160.187 103.706 160.187 102.864C160.187 102.022 159.23 101.34 158.049 101.34Z",
    fill: "#DDE4EE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4016 108.959H66.5179C65.3371 108.959 64.3799 109.641 64.3799 110.483C64.3799 111.325 65.3371 112.007 66.5179 112.007H96.4016C97.5825 112.007 98.5397 111.325 98.5397 110.483C98.5397 109.641 97.5825 108.959 96.4016 108.959Z",
    fill: "#DDE4EE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.295 116.579H66.5179C65.3371 116.579 64.3799 117.261 64.3799 118.103C64.3799 118.945 65.3371 119.627 66.5179 119.627H130.295C131.476 119.627 132.433 118.945 132.433 118.103C132.433 117.261 131.476 116.579 130.295 116.579Z",
    fill: "#DDE4EE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5177 50.4307C56.0372 50.4307 56.4583 50.009 56.4583 49.4888C56.4583 48.9686 56.0372 48.5469 55.5177 48.5469C54.9983 48.5469 54.5771 48.9686 54.5771 49.4888C54.5771 50.009 54.9983 50.4307 55.5177 50.4307Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.088 50.4307C59.6075 50.4307 60.0286 50.009 60.0286 49.4888C60.0286 48.9686 59.6075 48.5469 59.088 48.5469C58.5686 48.5469 58.1475 48.9686 58.1475 49.4888C58.1475 50.009 58.5686 50.4307 59.088 50.4307Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9381 50.4307C52.4576 50.4307 52.8787 50.009 52.8787 49.4888C52.8787 48.9686 52.4576 48.5469 51.9381 48.5469C51.4187 48.5469 50.9976 48.9686 50.9976 49.4888C50.9976 50.009 51.4187 50.4307 51.9381 50.4307Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.4971,
    y: 38.9307,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6395 44.6445H50.7824C50.4668 44.6445 50.2109 45.0027 50.2109 45.4445V55.8445C50.2109 56.2864 50.4668 56.6445 50.7824 56.6445H51.6395C51.9551 56.6445 52.2109 56.2864 52.2109 55.8445V45.4445C52.2109 45.0027 51.9551 44.6445 51.6395 44.6445Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2109 51.0731V50.216C57.2109 49.9004 56.8643 49.6445 56.4367 49.6445H45.9851C45.5576 49.6445 45.2109 49.9004 45.2109 50.216V51.0731C45.2109 51.3887 45.5576 51.6445 45.9851 51.6445H56.4367C56.8643 51.6445 57.2109 51.3887 57.2109 51.0731Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9973 38.9307C48.6805 38.9307 46.4157 39.6177 44.4893 40.9048C42.5629 42.192 41.0615 44.0215 40.1749 46.162C39.2883 48.3025 39.0563 50.6578 39.5083 52.9301C39.9603 55.2024 41.0759 57.2897 42.7142 58.9279C44.3524 60.5661 46.4397 61.6818 48.712 62.1338C50.9843 62.5858 53.3396 62.3538 55.4801 61.4672C57.6206 60.5806 59.4501 59.0792 60.7372 57.1528C62.0244 55.2264 62.7114 52.9616 62.7114 50.6448C62.7023 47.5408 61.4653 44.5665 59.2704 42.3717C57.0756 40.1768 54.1013 38.9397 50.9973 38.9307ZM48.5925 56.8904L42.5891 50.8869L44.273 49.203L48.5982 53.5282L57.7273 44.3991L59.4112 46.083L48.5925 56.8904L48.5925 56.8904Z",
    fill: "#1BCE6E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.124 150.766) rotate(90) scale(3.7664 80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF7",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessOperation);
export default __webpack_public_path__ + "static/media/successOperation.ba982e83d0993ae777856e0474cc8db4.svg";
export { ForwardRef as ReactComponent };